import * as React from 'react';
import PropTypes from 'prop-types';
var SvgNavigationProfileHighlightedMedium = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 18.67a24.6 24.6 0 00-15 0C4.78 19.94 4 21.71 4 23a13.45 13.45 0 001.1 5.47A1 1 0 006 29h20a1 1 0 00.9-.56A13.45 13.45 0 0028 23c0-1.29-.78-3.06-4.5-4.33zM16 15a6 6 0 10-6-6 6 6 0 006 6z"
  }));
});
SvgNavigationProfileHighlightedMedium.defaultProps = {
  height: 32,
  width: 32
};
SvgNavigationProfileHighlightedMedium.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgNavigationProfileHighlightedMedium;